import { useFormikContext } from 'formik'
import { InputField, InputGroupField } from 'components'
import CurrencyInputField from 'components/molecules/currency-input-field'
import ToggleField from 'components/molecules/toggle-field'
import { ITEM_DISCOUNT_TYPE } from 'domains/voucher/constants/voucher-constants'

/**
 * Wrapper of fields for Voucher Form
 * - Only to be used in Voucher Form
 */
const VoucherRuleItemFields = () => {

  // Get current values in the form for conditional rendering
  // Prevents having to have a state in this component
  const {
    initialValues,
    touched,
    values,
    setValues,
    setTouched,
    handleChange
  } = useFormikContext()

  // console.log(initialValues)

  /**
   * Reset all shipment_discount_... values
   * - uses setValues (not setFieldValues) due to async issue with react hooks and formik
   *
   * ref: https://github.com/jaredpalmer/formik/issues/2083#issuecomment-571259235
   */
  const handleChangeDiscountActive = () => {
    setValues({
      ...values,
      // dont call formik.handleChange since we are changing it here
      is_item_discount_active      : !values.is_item_discount_active,
      item_discount_type           : initialValues.item_discount_type,
      item_discount_absolute       : initialValues.item_discount_absolute,
      item_discount_percentage     : initialValues.item_discount_percentage,
      item_discount_percentage_max : initialValues.item_discount_percentage_max
    })

    // Skips validation on setTouched as recommended by formik creator jaredpalmer
    setTouched({
      ...touched,
      is_item_discount_active      : true,
      item_discount_type           : false,
      item_discount_absolute       : false,
      item_discount_percentage     : false,
      item_discount_percentage_max : false
    })
  }

  // Reset values to default when switching discount types
  // User can change the input value, and then switch
  const handleChangeDiscountType = (event) => {
    const isPercentage = event.target.value === ITEM_DISCOUNT_TYPE.PERCENTAGE
    const isAbsolute   = event.target.value === ITEM_DISCOUNT_TYPE.ABSOLUTE

    // change from absolute => percentage
    // reset absolute fields
    if (isPercentage) {
      // setFieldTouched('item_discount_absolute', false)
      // setFieldValue('item_discount_absolute', initialValues.item_discount_absolute)
      setValues({
        ...values,
        item_discount_absolute: initialValues.item_discount_absolute
      })
      setTouched({
        ...touched,
        item_discount_absolute: false
      })

    }
    // change from percentage => absoulte
    // reset percentage fields
    if (isAbsolute) {
      setValues({
        ...values,
        item_discount_percentage     : initialValues.item_discount_percentage,
        item_discount_percentage_max : initialValues.item_discount_percentage_max
      })

      setTouched({
        ...touched,
        item_discount_percentage     : false,
        item_discount_percentage_max : false
      })

    }
    handleChange(event)
  }

  return (
    <>
      { /** Checkbox so we do not need to convert string to boolean with InputField type='select'  */ }
      <ToggleField
        type={ 'checkbox' }
        id={ 'is_item_discount_active' }
        name={ 'is_item_discount_active' }
        label={ 'Is Item Discount Active?' }
        required={ true }
        onChange={ handleChangeDiscountActive }
        formText={ <>Apply discount on the <strong>Cart Items</strong> only</> }
      />
      {
        values.is_item_discount_active && (
          <>
            <InputField
              type='select'
              label='Item Discount Type'
              name='item_discount_type'
              placeholder='End of Season Sale 88k'
              required={ true }
              onChange={ handleChangeDiscountType }
              formText={ <>
                <strong>Absolute:</strong>{ ' Discount amount is applied to the sum of the cart item selling prices.' }
                <br />
                <strong>Percentage:</strong>{ ' Discount amount is a percentage of the sum of cart item selling prices.' }
              </> }
            >
              <option value={ 'absolute' }>Absolute</option>
              <option value={ 'percentage' }>Percentage</option>
            </InputField>

            {
              values.item_discount_type === 'absolute' && (
                <CurrencyInputField
                  label={ 'Item Discount Absolute Amount' }
                  name={ 'item_discount_absolute' }
                  required={ true }
                  formText={ <>
                    { 'Fixed amount to discount the shipment cost.' }<br />
                    <code>Shipment Cost - Absolute Amount = Customer Shipment Pay</code><br />
                    <code>30,000 - 10,000 = 20,000</code><br />
                    <code>30,000 - 40,000 = 0</code>
                  </> }
                />
              )
            }

            {
              values.item_discount_type === 'percentage' && (
                <>
                  <InputGroupField
                    label={ 'Item Discount Percetange' }
                    name={ 'item_discount_percentage' }
                    required={ true }
                    type='number'
                    min={ 0 }
                    max={ 100 }
                    addonType='append'
                    inputGroupText={ '%' }
                    formText={ <>
                      { 'Calculates the discount amount applied to each item based on a percentage of the item selling price.' }
                      <br />
                      <code>Item Selling Price x Percentage = Discount Amt</code>
                      <br />
                      <code>IDR 200,000 x 20% = IDR 40,000</code>
                    </>
                    }
                  />
                  <CurrencyInputField
                    label={ 'Item Discount Percentage Max' }
                    name={ 'item_discount_percentage_max' }
                    required={ true }
                    formText={ <>
                      { 'Limits item discount total from going over this value.' }
                      <br />
                      <code>Percentage Max: 30,000</code><br />
                      <code>Item Selling Price * Percentage = Item Discount</code><br />
                      <code>200,000 * 20% = 40,000</code><br />
                      <code>Item Discount is more than Percentage Max</code><br />
                      <code className={ 'font-weight-bolder' }>Customer Pays: 200,000 - 30,000 (Percentage Max) = 170,000</code>
                    </>
                    }
                  />
                </>
              )
            }
          </>
        )
      }

    </>
  )
}
export default VoucherRuleItemFields